import * as fc from './fast-check-default.js';
export default fc;
export * from './fast-check-default.js';
